import { z } from "zod/v4-mini";

import { DeviceType, deviceTypeSchema } from "@/models/MedicalDeviceModel.ts";
import { Schema, cz } from "@/utils/zodUtils.ts";

export const activityIntensitySchema = z.literal(["low", "medium", "high"]);
export type ActivityIntensity = z.infer<typeof activityIntensitySchema>;

export type Activity = {
  id: string;
  patientId: string;
  date: string;
  deviceId?: string;
  deviceType?: DeviceType;

  intensity?: ActivityIntensity;
  duration: number;
};

export const activitySchema: Schema<Activity> = cz.camelCaseObject({
  id: cz.id(),
  patient_id: z.string(),
  date: cz.datetime(),
  device_id: cz.optional(cz.id()),
  device_type: cz.optional(deviceTypeSchema),
  intensity: cz.optional(activityIntensitySchema),
  duration: z.number(),
});

export const getActivityIntensityTranslation = (intensity: ActivityIntensity | undefined): string => {
  switch (intensity) {
    case "low":
      return "models.activityIntensity.low";
    case "medium":
      return "models.activityIntensity.medium";
    case "high":
      return "models.activityIntensity.high";
    default:
      return "models.activityIntensity.unknown";
  }
};
